import {CustomerDashboardState} from "../store/customer_dashboard_state";
import {Reducer} from "redux";
import {
    CustomerDashboardAction,
    CustomerDashboardActionType, ICallbackGetAllByRecommendProjectListAction
} from "../action/customer_dashboard_action";

const initialState: CustomerDashboardState = {
    projectList: [],
};

const customerDashboardReducer: Reducer<CustomerDashboardState> = (state = initialState, action: CustomerDashboardAction): CustomerDashboardState => {
    switch (action.type) {
        case CustomerDashboardActionType.CALLBACK_GET_ALL_BY_RECOMMEND_PROJECT_LIST: {
            const _action = action as ICallbackGetAllByRecommendProjectListAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    applyClientList: _action.item,
                });
            } else {
                return state;
            }
        }
        default:
            return state;
    }
};

export default customerDashboardReducer;


// WEBPACK FOOTER //
// ./src/presentation/reducer/customer_dashboard_reducer.ts